import clsx from 'clsx';
import { AriaButtonProps } from 'react-aria';
import { Button } from './Button';

interface Props extends AriaButtonProps {
  isLoading?: boolean;
}

export const TertiaryButton = (props: Props) => {
  const { isDisabled, children } = props;

  return (
    <Button
      {...props}
      className={clsx(
        'min-w-[128px] px-6 py-2',
        isDisabled
          ? 'cursor-not-allowed bg-bp-gray text-bp-black'
          : 'bg-bp-green text-bp-indigo hover:bg-bp-pink hover:text-white',
      )}
    >
      {children}
    </Button>
  );
};
